import { Sheet, type SheetVariant } from '@sunwebgroup/uds-ui/sheet'
import * as React from 'react'
import { useIntl } from '@/intl'
import { createGroupsEvent } from '@/scopes/checkout/domain/analytics'
import { RoomSelectionForm } from '@/scopes/checkout/groups/components/services/RoomSelection/Sheet/Form'
import {
  roomSelectionServiceIsBeingSelected,
  useRoomSelectionServiceStore,
} from '@/scopes/checkout/groups/components/services/RoomSelection/store'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'

export function RoomSelectionServiceSheet() {
  const { isTablet } = useBreakpoints()
  const roomSelectionWrapperSide = isTablet ? 'right' : 'bottom' as SheetVariant
  const intl = useIntl()
  const { endSelectingRoomService } = useRoomSelectionServiceStore()
  const { sendEvent } = useAnalytics()

  const handleCancelClick = React.useCallback(() => {
    endSelectingRoomService()
    sendEvent(
      createGroupsEvent({
        description: 'RoomSelection',
        element: 'sheet',
        type: 'toggle',
        result: 'close sheet',
      }),
    )
  }, [sendEvent, endSelectingRoomService])

  const isSelectingRoom = useRoomSelectionServiceStore(roomSelectionServiceIsBeingSelected())

  return (
    <Sheet.Root open={isSelectingRoom} onOpenChange={open => !open && handleCancelClick()}>
      <Sheet.Body side={roomSelectionWrapperSide}>
        <Sheet.Header
          titleLabel={intl.formatMessage({ id: 'groups_checkout_steps_room_selection_sheet_title' })}
          closeLabel={intl.formatMessage({ id: 'groups_checkout_steps_room_selection_sheet_cancel_button' })}
        />
        <RoomSelectionForm />
      </Sheet.Body>
    </Sheet.Root>
  )
}
